import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { applyTenant } from "@/lib/brand";
import { buildNavItems } from "./layout/navConfig";
import { Sidebar } from "./layout/Sidebar";
import { Topbar } from "./layout/Topbar";

export default function Layout() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  const isClient = user.role === "client";
  const navItems = buildNavItems(user.role);

  useEffect(() => {
    if (isClient && user.client) {
      applyTenant(user.client.primary_color, user.client.accent_color);
    } else {
      applyTenant("#F7941E", "#0E4C7A");
    }
  }, [isClient, user]);

  return (
    <div className="flex h-screen overflow-hidden">
      <aside className="hidden md:block w-64 shrink-0">
        <Sidebar navItems={navItems} isClient={isClient} user={user} />
      </aside>

      {open && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <div className="absolute left-0 top-0 h-full w-64">
            <Sidebar navItems={navItems} isClient={isClient} user={user} onNavigate={() => setOpen(false)} />
          </div>
        </div>
      )}

      <div className="flex-1 flex flex-col min-w-0">
        <Topbar isClient={isClient} user={user} onOpenMenu={() => setOpen(true)} />
        <main className="flex-1 overflow-y-auto scroll-thin p-4 md:p-8 bg-slate-50">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
